import zViewInput from './input.vue'

zViewInput.install = Vue => Vue.component(zViewInput.name, zViewInput)

export default zViewInput